// Show all expandable for Family Product teasers on product detail page below first main section.
define(['jquery', 'requirejs-domready/domReady'], function ($) {
    'use strict';

    const parentElement = $('.catalog-product-view .family-products .widget-product-grid');
    // Stop if Widget Product Grid is not existing
    if (!parentElement.length) {
        return;
    }

    const showAllElement = 'widget-product-grid__show-all';
    const widgetProductGridItemsCount = parentElement.find('.product-item').length;
    const closeString = parentElement.data('close');
    const switchToMobileSize = 599;
    const desktop = {
        rows: 1,
        itemWidth: 100 + 26,
    };
    const mobile = {
        rows: 2,
        itemWidth: 70 + 13,
    };

    let settings = {};
    let maxVisibleItems = 0;
    let needShowAll = false;
    let hiddenItemsCount = 0;

    function getMaxVisibleItems() {
        return Math.floor(parentElement.width() / settings.itemWidth) * settings.rows;
    }

    function updateProperties() {
        settings = parentElement.width() <= switchToMobileSize ? mobile : desktop;
        maxVisibleItems = getMaxVisibleItems();
        needShowAll = widgetProductGridItemsCount > maxVisibleItems;
        hiddenItemsCount = widgetProductGridItemsCount - (maxVisibleItems - 1);
    }

    function updateShowAllButton() {
        // Get position of last element to "show all" button to position the button on top of the last image in the row
        const lastImage = $(`.widget-product-grid .product-item:nth-child(${maxVisibleItems})`);
        document.querySelector('html').style.setProperty('--widget-product-show-all-offset-top', `${lastImage.position().top}px`);
        document.querySelector('html').style.setProperty('--widget-product-show-all-offset-left', `${lastImage.position().left}px`);
        updateShowAllButtonContent();
    }

    function updateShowAllButtonContent() {
        let showAllContent = parentElement.hasClass('collapsed') ? `+${hiddenItemsCount}` : closeString;
        $(`.${showAllElement}`).text(showAllContent);
    }

    /** Initialize Grid */
    updateProperties();
    if (needShowAll) {
        parentElement.addClass('collapsed');
        //create and add a show all Button incl remaining image count
        $('.collapsed').append(`<div class="product-item ${showAllElement}">+${hiddenItemsCount}</div>`);
        updateShowAllButton();

        $(`.${showAllElement}`).click(function () {
            parentElement.toggleClass('collapsed');
            updateShowAllButtonContent();
        });
    }

    $(window).on('resize', function () {
        updateProperties();
        if (needShowAll) {
            updateShowAllButton(maxVisibleItems);
        }
    })
});
